import { css } from '@emotion/react';
import { gray5, primary } from 'styles/global_defaults/colors';

export const assigneeCellStyles = css`
  .nv-dropdown,
  .bs4-dropdown {
    width: 100%;
  }

  .bs4-dropdown {
    border-color: ${gray5} !important;
  }

  .bs4-dropdown-menu {
    width: 100% !important;
    min-width: 100% !important;
  }

  .title:focus-visible {
    outline: 2px solid ${primary};
    outline-offset: -2px;
  }
`;
